import { selectFromRouteTimelineDto } from '../../models';

export default selectFromRouteTimelineDto()
  .eventUuid
  .orderUuid
  .eventType
  .stopSequence
  .sequence
  .departureTime
  .arrivalTime
  .startTime
  .endTime
  .isArrived
  .isDeparted
  .eta(eta => eta
    .expectedArrivalTime
    .expectedFinishTime
    .originalArrivalTime
    .originalFinishTime
    .actualArrivalTime
    .actualFinishTime)
  .constraints(constraint => constraint
    .address)
  .orders(order => order
    .uuid
    .name
    .isCompleted
    .isScheduled
    .isDateMismatched
    .customerOrderNumber
    .attempts(attempt => attempt
      .eventUuid
      .status
      .reattemptRequestDate)
    .locations(location => location.id.address.originalAddress.latitude.longitude.active.bestMatch)
    .timeWindows(timeWindow => timeWindow.startTime.endTime))
  .toString();
